module.exports = __webpack_public_path__ + "media/images/ui__textCross-ea08d99dd65ad9ad81dee62a4986f1d1.png";